import { STATE_ENUM } from "@/utils/consts"
import { dateToString, now, FMTS } from "@/utils/datetime"
import { HTTP } from "@/utils/http-common"

export default {
  async getAll(companyId, queryArgs = null) {
    const path = `/documents/company/${companyId}/templates`
    let results = (await HTTP.get(path, { params: queryArgs })).data
    results.sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
    return results
  },

  async getAllTemplate() {
    const path = `/documents/templates`
    return (await HTTP.get(path)).data
  },

  async get(templateId) {
    const path = `/documents/templates/${templateId}`
    return (await HTTP.get(path)).data
  },

  async get_latest(companyId) {
    const path = `/documents/templates/last/${companyId}`
    return (await HTTP.get(path)).data
  },

  async post(data) {
    let companyId = data.company.pk
    const path = `/documents/company/${companyId}/templates`
    return (await HTTP.post(path, data)).data
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/documents/templates/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(templateId) {
    const path = `/documents/templates/${templateId}`
    return (await HTTP.delete(path)).data
  },

  async publish(templateId) {
    const path = `/documents/templates/${templateId}`
    const data = { state: STATE_ENUM.PUBLISHED }
    return (await HTTP.patch(path, data)).data
  },

  async revoke(templateId) {
    const path = `/documents/templates/${templateId}`
    const data = { state: STATE_ENUM.REVOKED }
    return (await HTTP.patch(path, data)).data
  },

  async duplicate(templateId, company = null) {
    let responseGet = await this.get(templateId)
    let date = dateToString(now(), FMTS.FILE)
    responseGet.name = `${responseGet.name}-${date}`
    responseGet.state = STATE_ENUM.EDITABLE
    responseGet.company = company ? company : responseGet.company
    let responsePost = await this.post(responseGet)
    let responseDetails = await this.details.get(templateId)
    responseDetails.id = responsePost.id
    return await this.details.put(responseDetails)
  },

  details: {
    async get(templateId) {
      const path = `/documents/templates/${templateId}/details`
      return (await HTTP.get(path)).data
    },
    async put(data) {
      const { id, ...others } = data
      const path = `/documents/templates/${id}/details`
      return (await HTTP.put(path, others)).data
    }
  },

  types: {
    async getAll() {
      const path = `/documents/templates/types`
      return (await HTTP.get(path)).data
    }
  }
}
